module.exports = __webpack_public_path__ + "static/media/zllc1.23d8e9e7.png";